import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { createContext, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import { siteThemes } from '../../utils/theming.js';
import { jsx, Fragment } from 'react/jsx-runtime';

var _excluded = ["siteId", "culture", "legacyMode", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultCultures = {
  1: 'sv-SE',
  3: 'nb-NO',
  11: 'da-DK',
  15: 'fi-FI',
  18: 'sv-SE'
};

/**
 * Retrieves the site theme based on the provided id and legacy mode.
 *
 * @param {number} id - The id of the site theme.
 * @param {boolean} legacyMode - Indicates whether the legacy mode is enabled.
 * @returns {string} The site theme.
 */
var getSiteTheme = function getSiteTheme(id, legacyMode) {
  if (legacyMode) {
    return siteThemes.DEFAULT;
  }
  switch (id) {
    case 18:
      return siteThemes.GLOBETROTTER;
    default:
      return siteThemes.DEFAULT;
  }
};
var Context = /*#__PURE__*/createContext({
  siteId: 1,
  culture: null,
  theme: {
    site: siteThemes.DEFAULT,
    mode: 'light'
  }
});

/**
 * Renders the Globals component.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number|string} [props.siteId=1] - The site ID.
 * @param {'sv-SE'|'nb-NO'|'da-DK'|'fi-FI'} [props.culture=null] - The culture.
 * @param {boolean} [props.legacyMode=false] - The legacy mode flag.
 * @param {React.ReactNode} [props.children=null] - The child components.
 * @param {Object} [props.rest] - Additional props to be spread on the component.
 * @returns {JSX.Element} The rendered Globals component.
 */
var Globals = function Globals(_ref) {
  var _ref$siteId = _ref.siteId,
    siteId = _ref$siteId === void 0 ? 1 : _ref$siteId,
    _ref$culture = _ref.culture,
    culture = _ref$culture === void 0 ? null : _ref$culture,
    _ref$legacyMode = _ref.legacyMode,
    legacyMode = _ref$legacyMode === void 0 ? false : _ref$legacyMode,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var checkedSiteId = parseInt(siteId, 10) || 1;
  var checkedCulture = culture || defaultCultures[checkedSiteId] || 'en';
  var siteTheme = getSiteTheme(checkedSiteId, legacyMode);
  var globals = useMemo(function () {
    return _objectSpread(_objectSpread({}, rest), {}, {
      theme: {
        site: siteTheme
      },
      culture: checkedCulture,
      siteId: checkedSiteId,
      legacyMode: legacyMode
    });
  }, [checkedCulture, checkedSiteId, siteTheme, legacyMode, rest]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: globals,
    children: /*#__PURE__*/jsx(ThemeProvider, {
      theme: globals.theme,
      children: /*#__PURE__*/jsx(Fragment, {
        children: children
      })
    })
  });
};

export { Context, Globals };
//# sourceMappingURL=Globals.js.map
